var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVigilSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 32,
    viewBox: "0 0 128 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vigil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6396 12.5484L43.7908 22.3675L46.9092 12.5484H49.2891L44.8741 25.3168H42.6912L38.2598 12.5484H40.6396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3804 25.3168V12.5484H62.6454V25.3168H60.3804Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.766 25.4067C79.011 25.4067 78.2943 25.2389 77.6159 24.9032C76.9485 24.5675 76.3576 24.1059 75.8433 23.5184C75.34 22.919 74.9461 22.2236 74.6616 21.4323C74.3771 20.6411 74.2349 19.7838 74.2349 18.8607C74.2349 17.9855 74.3771 17.1642 74.6616 16.3969C74.9461 15.6176 75.3455 14.9342 75.8598 14.3468C76.374 13.7593 76.9758 13.2977 77.6651 12.962C78.3545 12.6263 79.104 12.4585 79.9137 12.4585C81.0079 12.4585 81.9434 12.7163 82.7202 13.2318C83.5081 13.7353 84.0989 14.4067 84.4928 15.246L82.8023 16.6127C82.5069 15.9773 82.0911 15.4917 81.5549 15.156C81.0297 14.8203 80.4553 14.6525 79.8316 14.6525C79.3392 14.6525 78.8906 14.7664 78.4858 14.9942C78.0809 15.222 77.7308 15.5337 77.4354 15.9293C77.1399 16.325 76.9102 16.7806 76.746 17.2961C76.5928 17.8116 76.5163 18.3571 76.5163 18.9326C76.5163 19.544 76.5983 20.1075 76.7624 20.6231C76.9375 21.1386 77.1782 21.5882 77.4846 21.9718C77.8019 22.3555 78.1685 22.6612 78.5843 22.889C79 23.1048 79.4596 23.2127 79.9629 23.2127C80.5538 23.2127 81.1173 23.0449 81.6534 22.7092C82.2005 22.3735 82.7093 21.8819 83.1798 21.2345V23.6803C82.206 24.8312 81.068 25.4067 79.766 25.4067ZM83.0157 20.5691H80.6687V18.7528H84.8867V25.3168H83.0157V20.5691Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6646 25.3168V12.5484H98.9295V25.3168H96.6646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.208 25.3168V12.5484H113.473V23.1408H119.415V25.3168H111.208Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2381 8.93873C11.2856 19.9394 9.34125 23.5903 9.34125 23.7665C9.34125 23.9517 12.5144 29.9765 13.5496 31.7566C13.7415 32.0869 14.1932 32.0789 14.3748 31.7421L15.0829 30.4294C15.6931 29.2983 18.8165 23.5149 22.0237 17.5775C25.2307 11.6402 27.8818 6.71149 27.9149 6.62503C27.9478 6.53838 25.8476 6.49041 23.2477 6.51809L21.0793 6.54131C19.4931 6.5583 18.033 7.46962 17.2381 8.93873Z",
    fill: "url(#paint0_linear_12670_114494)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9609 15.0157C13.0355 13.2998 11.9476 11.2867 10.6771 8.93875C9.88226 7.46964 8.42213 6.55832 6.83594 6.54134L4.66757 6.51811C2.0677 6.49043 -0.0325702 6.5384 0.000382531 6.62505C0.0335117 6.71151 2.68458 11.6402 5.89159 17.5775C9.09878 23.5149 12.2222 29.2983 12.8323 30.4295L13.5404 31.7421C13.7221 32.079 14.1737 32.0869 14.3657 31.7567C14.9174 30.8078 16.0766 28.6531 17.0389 26.8195L23.4036 15.0215C22.4599 16.7623 20.6996 17.9329 18.6838 17.9329C16.6658 17.9329 14.9038 16.7596 13.9609 15.0157Z",
    fill: "url(#paint1_linear_12670_114494)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.158 0V0.411493H123.095V3.45419H122.662V0.411493H121.6V0H124.158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.979 0H125.591L126.496 2.92043L127.395 0H128.001V3.45419H127.595V1.41554C127.595 1.345 127.596 1.22821 127.599 1.06518C127.602 0.90215 127.604 0.727364 127.604 0.54082L126.704 3.45419H126.282L125.376 0.54082V0.646633C125.376 0.731283 125.378 0.860609 125.38 1.03461C125.385 1.20705 125.387 1.33402 125.387 1.41554V3.45419H124.979V0Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12670_114494",
    x1: 28.0042,
    y1: 31.784,
    x2: -0.323829,
    y2: 31.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12670_114494",
    x1: -6.8114,
    y1: 19.2476,
    x2: 21.0137,
    y2: 19.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A0FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigilSmallLogo);
export default __webpack_public_path__ + "static/media/vigilSmallLogo.998f431cc79e3deea0af77038a8cc0a5.svg";
export { ForwardRef as ReactComponent };